<template lang="pug">
#ShowAbout.bottom-2.left-1.absolute( @click="$emit('open')").pointer
    img.dim(src="../assets/wwr.png")
</template>

<script>
export default {
    name: 'ShowAbout',
    data: () => ({}),
    created() {
        window.ShowAbout = this;
    },
};
</script>

<style scoped>
#ShowAbout {
    cursor: pointer;
    pointer-events: all;
}
img {
    width: 100px;
}
</style>
